import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[vfsBackground]'
})
export class BackgroundDirective implements AfterViewInit {
  protected element: HTMLElement;

  @Input('vfsBackground') url: string;

  constructor(element: ElementRef) {
    this.element = element.nativeElement;
  }

  ngAfterViewInit() {
    this.element.style.backgroundImage = `url(${this.url})`;
  }
}
